import { useTranslation } from 'react-multi-lang';
import MyDialog from '../../../components/Dialog/dialog';
import TreeSelect from '../../../components/TreeCheckbox/TreeCheckbox';
import { Grid } from '@mui/material';
import GreenButton from '../../../components/buttons/green-button';
import WhiteButton from '../../../components/buttons/white-button';
import { useState } from 'react';

interface iChoice {
  value: string;
  label: string;
}

interface iNode {
  value: string;
  label: string;
  children: iChoice[];
}
interface iProps {
  setOpen: Function;
  open: boolean;
  checked: string[];
  setChecked: Function;
  nodes: iNode[];
}

export default function PermissionModal({
  checked,
  setChecked,
  setOpen,
  nodes,
  open,
}: iProps) {
  const t = useTranslation();
  const[isDirty,setIsDirty]=useState(false)
  const handleChecked=(val:string[])=>{
    setChecked(val)
   if(!isDirty)   setIsDirty(true)
  
  }
  return (
    <MyDialog setOpen={setOpen} open={open} title={t('role_details')}>
      <Grid container rowGap={4} paddingTop={2}>
        <Grid  size={12} justifyContent={'center'}>
          <TreeSelect
            checked={checked}
            setChecked={handleChecked}
            nodes={nodes}
            disabled={false}
          />
        </Grid>
        <Grid container size={12} justifyContent={'center'}>
          <Grid size={4}>
            {isDirty &&
              <GreenButton fun={() => setOpen(false)} label={t('save')} />
            }
          </Grid>
          <Grid size={4}>
            <WhiteButton fun={() => setOpen(false)} label={t('cancel')} />
          </Grid>
        </Grid>
      </Grid>
    </MyDialog>
  );
}
